<div class="detail-container" [nbSpinner]="!!(loading$|async)">
  <nb-card>
    <nb-card-header class="noselect flex-container">
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5 class="headline">Rundgang</h5>
      @if (hasSendingStatus) {
        <wr-banner [icon]="{icon: 'alert-triangle-outline', pack: 'eva'}"
                   status="warning"
                   message="Rundgang wurde bereits versendet und sollte nicht mehr bearbeitet werden.">
        </wr-banner>
      }
      @if (willApplyPreviousInspection) {
        <wr-banner [icon]="{icon: 'info-outline', pack: 'eva'}"
                   status="info"
                   message="Früherer Rundgang wird als Vorlage verwendet.">
        </wr-banner>
      }
      <div class="flex-grow"></div>
      <div class="button-group">
        @if (!lockEdit) {
          @if (canEdit()) {
            @if (formWrapper.disabled()) {
              <button nbButton
                      size="small"
                      [disabled]="(!(inspection?.status === 'DONE' || inspection?.status === 'SENT'))"
                      (click)="showEmailDialog(inspection!)">
                <nb-icon pack="eva" icon="email-outline"></nb-icon>
                <span>Email senden</span>
              </button>
            }
            @if (formWrapper.disabled()) {
              <button nbButton
                      status="basic"
                      nbTooltip="Bearbeiten"
                      (click)="formWrapper.enable()">
                <nb-icon pack="eva" icon="edit-outline"></nb-icon>
              </button>
            }
            @if (formWrapper.enabled()) {
              <button nbButton
                      status="danger"
                      nbTooltip="Abbrechen"
                      (click)="cancel()">
                <nb-icon pack="eva" icon="close-outline"></nb-icon>
              </button>
            }
            @if (formWrapper.enabled()) {
              <button nbButton
                      status="success"
                      nbTooltip="Speichern"
                      [disabled]="submitting()"
                      (click)="saveInspection()">
                <nb-icon pack="eva" icon="checkmark-outline"></nb-icon>
              </button>
            }
            @if (formWrapper.disabled() && !isNew) {
              <button nbButton
                      status="danger"
                      (click)="showDeleteDialog()"
                      nbTooltip="Löschen">
                <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
              </button>
            }
          }
        } @else {
          <wr-banner [icon]="{icon: 'alert-triangle-outline', pack: 'eva'}"
                     status="danger"
                     message="Rundgang wird gerade bearbeitet"></wr-banner>
          <button nbButton status="danger" size="small" ghost outline (click)="showEditOverrideDialog()">
            Trotzdem bearbeiten
          </button>
        }
      </div>
    </nb-card-header>
    <nb-card-body>
      @if (formWrapper.form(); as form) {
        <nb-tabset (changeTab)="changeTab($event)"
                   routeParam="inspectionTab">
          <nb-tab tabTitle="Allgemein"
                  [tabId]="general_tab"
                  [route]="general_tab">
            <wr-detail-form [formWrapper]="formWrapper">
            </wr-detail-form>
          </nb-tab>
          @if (!isNew && inspection) {
            <nb-tab tabTitle="Archiv"
                    [tabId]="archive_tab"
                    [route]="archive_tab">
              <wr-archive-tab [formWrapper]="formWrapper"
                              [inspection]="inspection!">
              </wr-archive-tab>
            </nb-tab>
          }
          @if (!isNew) {
            <nb-tab tabTitle="Prüfpunktzeilen"
                    [tabId]="entries_tab"
                    [route]="entries_tab">
              @if (inspection) {
                <wr-inspection-entries [formWrapper]="formWrapper"
                                       [inspection]="inspection"
                                       (importing$)="importing$.next($event)"
                                       (repairTaskCreated)="inspectionContext.reloadRepairTasks()">
                </wr-inspection-entries>
              }
            </nb-tab>
          }
          @if (!isNew) {
            <nb-tab tabTitle="TGAs"
                    [tabId]="building_equipments_tab"
                    class="no-padding"
                    [route]="building_equipments_tab">
              <wr-building-equipments-cockpit [formWrapper]="formWrapper"></wr-building-equipments-cockpit>
            </nb-tab>
          }
          @if (formWrapper.disabled() && !isNew && inspection) {
            <nb-tab tabTitle="Downloads"
                    [tabId]="pdfs_tab"
                    [route]="pdfs_tab">
              <wr-inspection-pdfs [inspection]="inspection">
              </wr-inspection-pdfs>
            </nb-tab>
          }
          @if (formWrapper.disabled() && !isNew && inspection && inspectionContext.repairTasksVisible()) {
            <nb-tab tabTitle="Reparaturaufträge"
                    [tabId]="repair_tasks_tab"
                    [route]="repair_tasks_tab">
              <wr-repair-tasks [inspection]="inspection"></wr-repair-tasks>
            </nb-tab>
          }
          @if (!isNew && inspection && canEdit()) {
            <nb-tab tabTitle="Notizen"
                    [tabId]="notes_tab"
                    [route]="notes_tab">
              <wr-inspection-notes [inspection]="inspection!"
                                   (inspectionChange)="inspection = $event"></wr-inspection-notes>
            </nb-tab>
          }
          @if (inspection) {
            <nb-tab tabTitle="Metadata"
                    [tabId]="meta_data_tab"
                    [route]="meta_data_tab">
              <wr-meta-data [inspection]="inspection" [formWrapper]="formWrapper"></wr-meta-data>
            </nb-tab>
          }
        </nb-tabset>
      }
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <span class="last-saved">Zuletzt
          gespeichert: {{ inspection?.lastSavedTimeStamp | date: 'dd.MM.yyyy HH:mm' }}</span>
        <div class="flex-grow"></div>
        @if (hasAnyPendingAttachments) {
          <nb-icon icon="sync-outline"
                   pack="eva"
                   status="danger"
                   nbTooltip="Bilder werden hochgeladen"></nb-icon>
        }
        <button [disabled]="formWrapper.disabled() || submitting()" nbButton status="primary" (click)="saveInspection()">
          Speichern
        </button>
        <button [disabled]="formWrapper.disabled()" nbButton status="basic" (click)="cancel()">Abbrechen</button>
      </nb-card-footer>
    }
  </nb-card>
</div>

@if (!isNew && clerkGuidelines() && canEdit()) {
  <wr-inspection-guidelines-window
    [inspectionId]="inspection!.id"
    type="CLERK"
    (saved)="clerkGuidelines.set($event)">
  </wr-inspection-guidelines-window>
}
